import { __awaiter, __generator } from "tslib";
export var appCustomJsApiRelativePath = "/snippets/js";
export var createAppCustomJsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + appCustomJsApiRelativePath;
    return {
        get: function () { return http.get("" + apiUrl); },
        update: function (dto) { return http.put("" + apiUrl, dto.data); },
        append: function (dto) { return __awaiter(void 0, void 0, void 0, function () {
            var currentJs, updatedJs, data, updatedSnippet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http.get("" + apiUrl)];
                    case 1:
                        currentJs = _a.sent();
                        updatedJs = currentJs.content + '\n' + dto.data.content;
                        data = { content: updatedJs };
                        return [4 /*yield*/, http.put("" + apiUrl, data)];
                    case 2:
                        updatedSnippet = _a.sent();
                        return [2 /*return*/, updatedSnippet];
                }
            });
        }); }
    };
};
//# sourceMappingURL=index.js.map